import React from "react";
import RemoveRetakesSidebar from "../RemoveRetakesSidebar";
import type { RetakesReviewWorkflow } from "../hooks/useRetakesReviewWorkflow";

type RetakesToolSidebarProps = {
    workflow: RetakesReviewWorkflow;
};

const RetakesToolSidebar: React.FC<RetakesToolSidebarProps> = ({ workflow }) => {
    return (
        <RemoveRetakesSidebar
            onBack={workflow.done}
            onDetect={() => {
                void workflow.detect();
            }}
            onDone={workflow.done}
            onAcceptAllRemaining={() => {
                void workflow.acceptAllRemaining();
            }}
            onPreviewClick={workflow.seekToDetection}
            onAcceptOne={(id) => {
                void workflow.acceptDetection(id);
            }}
            onRejectOne={(id) => {
                void workflow.rejectDetection(id);
            }}
            isLoading={workflow.isDetecting}
            isApplying={workflow.isApplyingAll}
            hasRun={workflow.hasRun}
            error={workflow.error}
            draft={workflow.draft}
            statusById={workflow.statusById}
            busyById={workflow.busyById}
            activeId={workflow.activeDetectionId}
        />
    );
};

export default RetakesToolSidebar;
